export const FEATURES = ['DELETE_ACCOUNT', 'AI_TOOLS'] as const;
export type Feature = (typeof FEATURES)[number];
